import {LANGUAGE_HAS_CHANGED, LOAD_ORDER_SUCCESS, MANAGE_LOADING, SUCCESS_API_CALL} from "../constants/action-types";

const initialState = {
    styles:{"CommonSettings":{"Logo":"image","HeaderBackgroundColor":"#000000","BackgroundColor":"#111111","FontFamily":"Georgia","FontColor":"#000333","DefaultLanguage":"en","SecondaryLanguage":"sv"},"ReadyForDelivery":{"ButtonBackGroundColor":"#112233","ButtonFontColor":"#332211"},"EnterCarPlateNumber":{"ButtonBackGroundColor":"#112233","ButtonFontColor":"#112233"},"WaitingForArrival":{"ButtonBackGroundColor":"#112233","ButtonFontColor":"#112233"},"WaitingQueue":{"Enabled":true,"UseCustom":true,"Show":true,"Image":"image"},"StaffOnTheWay":{"UseCustom":true,"Show":true,"Image":"image"},"ManualUpdate":{"ButtonBackGroundColor":"#112233","ButtonFontColor":"#112233"},"SuccessfulDelivery":{"UseCustom":true,"Show":true,"Image":"image"},"SuccessfulDeliveryWhenOrderWasDeliveredEarlier":{"UseCustom":true,"Show":true,"Image":"image"}},
    loading: true,
    order:{"StoreName":"#####","StoreId":0, "OrderNumber":"########","LinkCode":"#####","OrderStatus":"###", "DomainId":0, "CarPlateEnabled":false, "CarPlate":"", "QueueNumber":-1},
    currentLanguage: ''
};

const globalReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SUCCESS_API_CALL:{
            return {
                ...state,
                styles: action.data
            };
        }
        case LOAD_ORDER_SUCCESS:{
            return Object.assign({}, state, {
                ...state,
                order : action.data
            });
        }
        case MANAGE_LOADING: {
            return {
                ...state,
                loading: action.data
            };
        }
        case LANGUAGE_HAS_CHANGED:
            return {
                ...state,
                currentLanguage: action.lng
            };
        default:
            return state;
    }
};

export default globalReducer;
